const FETCH_SETTLEMENT_REQUEST = 'FETCH_SETTLEMENT_REQUEST';
const FETCH_SETTLEMENT_SUCCESS = 'FETCH_SETTLEMENT_SUCCESS';
const FETCH_SETTLEMENT_ERROR = 'FETCH_SETTLEMENT_ERROR';
const HIDE_SETTLEMENT_LOADER = 'HIDE_SETTLEMENT_LOADER';
const SHOW_SETTLEMENT_LOADER = 'SHOW_SETTLEMENT_LOADER';
const FETCH_SETTLEMENT_METRICS_REQUEST = 'FETCH_SETTLEMENT_METRICS_REQUEST';
const FETCH_SETTLEMENT_METRICS_SUCCESS = 'FETCH_SETTLEMENT_METRICS_SUCCESS';
const FETCH_SETTLEMENT_METRICS_ERROR = 'FETCH_SETTLEMENT_METRICS_ERROR';

const RETRY_SETTLEMENT_REQUEST = 'RETRY_SETTLEMENT_REQUEST';
const RETRY_SETTLEMENT_SUCCESS = 'RETRY_SETTLEMENT_SUCCESS';
const RETRY_SETTLEMENT_ERROR = 'RETRY_SETTLEMENT_ERROR';

const RETRIGGER_SETTLEMENT_REQUEST = 'RETRIGGER_SETTLEMENT_REQUEST';
const RETRIGGER_SETTLEMENT_SUCCESS = 'RETRIGGER_SETTLEMENT_SUCCESS';
const RETRIGGER_SETTLEMENT_ERROR = 'RETRIGGER_SETTLEMENT_ERROR';

// to fetch the data in todays summary of settlement view
const FETCH_AVAILABLE_BALANCE_REQUEST = 'FETCH_AVAILABLE_BALANCE_REQUEST';
const FETCH_AVAILABLE_BALANCE_SUCCESS = 'FETCH_AVAILABLE_BALANCE_SUCCESS';
const FETCH_AVAILABLE_BALANCE_ERROR = 'FETCH_AVAILABLE_BALANCE_ERROR';
const FETCH_NET_SETTLEMENT_REQUEST = 'FETCH_NET_SETTLEMENT_REQUEST';
const FETCH_NET_SETTLEMENT_SUCCESS = 'FETCH_NET_SETTLEMENT_SUCCESS';
const FETCH_NET_SETTLEMENT_ERROR = 'FETCH_NET_SETTLEMENT_ERROR';
const SET_AVAILABLE_BALANCE_LOADING = 'SET_AVAILABLE_BALANCE_LOADING';
const REMOVE_AVAILABLE_BALANCE_LOADING = 'REMOVE_AVAILABLE_BALANCE_LOADING';
// to fetch the data on after clicking settle now button (pop up data)
const FETCH_ODS_FEE_DETAILS_REQUEST = 'FETCH_ODS_FEE_DETAILS_REQUEST';
const FETCH_ODS_FEE_DETAILS_SUCCESS = 'FETCH_ODS_FEE_DETAILS_SUCCESS';
const FETCH_ODS_FEE_DETAILS_ERROR = 'FETCH_ODS_FEE_DETAILS_ERROR';

// the final button of settle now on the pop - up
const PROCESS_ODS_REQUEST = 'PROCESS_ODS_REQUEST';
const PROCESS_ODS_SUCCESS = 'PROCESS_ODS_SUCCESS';
const PROCESS_ODS_ERROR = 'PROCESS_ODS_ERROR';

const SET_ODS_PAGE_LOADING = 'SET_ODS_PAGE_LOADING';
const REMOVE_ODS_PAGE_LOADING = 'REMOVE_ODS_PAGE_LOADING';

const SET_PROCESS_LOADING = 'SET_PROCESS_LOADING';
const REMOVE_PROCESS_LOADING = 'REMOVE_PROCESS_LOADING';
const GET_MERCHANT_SECTION_INFO_REQUEST = 'GET_MERCHANT_SECTION_INFO_REQUEST_SETTLEMENT';

export {
    FETCH_SETTLEMENT_REQUEST,
    FETCH_SETTLEMENT_SUCCESS,
    FETCH_SETTLEMENT_ERROR,
    HIDE_SETTLEMENT_LOADER,
    SHOW_SETTLEMENT_LOADER,
    FETCH_SETTLEMENT_METRICS_SUCCESS,
    FETCH_SETTLEMENT_METRICS_REQUEST,
    FETCH_SETTLEMENT_METRICS_ERROR,
    RETRY_SETTLEMENT_REQUEST,
    RETRY_SETTLEMENT_SUCCESS,
    RETRY_SETTLEMENT_ERROR,
    RETRIGGER_SETTLEMENT_REQUEST,
    RETRIGGER_SETTLEMENT_SUCCESS,
    RETRIGGER_SETTLEMENT_ERROR,
    FETCH_AVAILABLE_BALANCE_REQUEST,
    FETCH_AVAILABLE_BALANCE_SUCCESS,
    FETCH_AVAILABLE_BALANCE_ERROR,
    FETCH_ODS_FEE_DETAILS_REQUEST,
    FETCH_ODS_FEE_DETAILS_SUCCESS,
    FETCH_ODS_FEE_DETAILS_ERROR,
    PROCESS_ODS_REQUEST,
    PROCESS_ODS_SUCCESS,
    PROCESS_ODS_ERROR,
    SET_AVAILABLE_BALANCE_LOADING,
    REMOVE_AVAILABLE_BALANCE_LOADING,
    SET_ODS_PAGE_LOADING,
    REMOVE_ODS_PAGE_LOADING,
    SET_PROCESS_LOADING,
    REMOVE_PROCESS_LOADING,
    GET_MERCHANT_SECTION_INFO_REQUEST,
    FETCH_NET_SETTLEMENT_REQUEST,
    FETCH_NET_SETTLEMENT_SUCCESS,
    FETCH_NET_SETTLEMENT_ERROR,
};
